module.exports = __webpack_public_path__ + "img/star_06.png";